/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="6">
            <div className="copyright text-center text-xl-left text-muted">
              © {new Date().getFullYear()} {" "}
              <a
                className="font-weight-bold ml-1 "
                href="https://www.uberlandia.mg.gov.br/"
                target="_blank"
              >
                Prefeitura Municipal de Uberlândia
                  </a>
            </div>
          </Col>

          <Col xl="6">
            <Nav className="nav-footer justify-content-center justify-content-xl-end">
              <NavItem>
                <NavLink
                  href="https://www.uberlandia.mg.gov.br/prefeitura/secretarias/saude/centro-de-controle-de-zoonoses/"
                  target="_blank"
                >
                  Zoonoses
                    </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://play.google.com/store/apps/details?id=br.gov.mg.prodaub.udisemdengue&hl=pt_BR"
                  target="_blank"
                >
                  Udi Sem Dengue
                    </NavLink>
              </NavItem> </Nav>
          </Col>
        </Row>
      </footer>
    );
  }
}

export default Footer;
